import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { PushPipe } from '@ngrx/component';

import { I18nService, TranslatePipe } from '@recruitee/i18n';
import { OfferSelectComponent, OfferSelectOption } from '@recruitee/offers-ui';
import {
  BoxComponent,
  ButtonComponent,
  DialogBodyComponent,
  DialogComponentI,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
  HeadingComponent,
} from '@recruitee/user-interface';

export interface CandidateSharingOfferSelectDialogData {
  offerIds: number[];
  selectOptions: OfferSelectOption[];
  isBulk: boolean;
}

export type CandidateSharingOfferSelectDialogResult = number | null | undefined;

@Component({
  selector: 'rt-candidate-sharing-offset-select-dialog',
  templateUrl: './candidate-sharing-offer-select-dialog.component.html',
  styleUrls: ['./candidate-sharing-offer-select-dialog.component.less'],
  standalone: true,
  imports: [
    DialogHeaderComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    ButtonComponent,
    TranslatePipe,
    BoxComponent,
    HeadingComponent,
    PushPipe,
    ReactiveFormsModule,
    OfferSelectComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateSharingOfferSelectDialogComponent
  implements
    DialogComponentI<
      CandidateSharingOfferSelectDialogData,
      CandidateSharingOfferSelectDialogResult
    >
{
  public offerIds: number[];
  public selectOptions: OfferSelectOption[] = [];
  public formControl = new FormControl<number | null>(null);
  public heading: string;

  constructor(
    private cdRef: ChangeDetectorRef,
    private dialogRef: DialogRef<CandidateSharingOfferSelectDialogComponent>,
    private i18n: I18nService,
  ) {}

  public setDialogData(data: CandidateSharingOfferSelectDialogData, triggerUpdate: boolean): void {
    this.offerIds = data.offerIds;
    this.selectOptions = data.selectOptions;
    this.formControl.setValue(!this.selectOptions[0]?.id ? null : +this.selectOptions[0].id);
    this.heading = this.i18n.translate(
      data.isBulk
        ? 'app.candidate.admin_select.share_with_team.job_select_dialog.dialog_heading_multiple'
        : 'app.candidate.admin_select.share_with_team.job_select_dialog.dialog_heading',
    );

    if (triggerUpdate) {
      this.cdRef.detectChanges();
    }
  }

  public cancel() {
    this.dialogRef.close(null);
  }

  public submit() {
    if (!this.formControl.value) {
      return;
    }

    this.dialogRef.close(this.formControl.value);
  }
}
